import { render, staticRenderFns } from "./EndorsementsPropertyQuotatorView.vue?vue&type=template&id=1bb3323c&scoped=true&"
import script from "./EndorsementsPropertyQuotatorView.vue?vue&type=script&lang=js&"
export * from "./EndorsementsPropertyQuotatorView.vue?vue&type=script&lang=js&"
import style0 from "./EndorsementsPropertyQuotatorView.vue?vue&type=style&index=0&id=1bb3323c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb3323c",
  null
  
)

export default component.exports